"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleTextAreaField = SimpleTextAreaField;
exports.default = TextAreaField;

var _react = _interopRequireDefault(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Field = _interopRequireDefault(require("../Field"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SimpleTextAreaField(p) {
  return /*#__PURE__*/_react.default.createElement("textarea", _extends({}, p.textareaProps, {
    className: (0, _classnames2.default)('textarea', _defineProperty({
      'is-danger': p.danger,
      'is-success': p.success
    }, "is-".concat(p.size), p.size)),
    value: p.value,
    onChange: p.onChange,
    ref: p.setRef,
    onFocus: p.onFocus,
    onBlur: p.onBlur,
    disabled: p.disabled
  }));
}

function TextAreaField(props) {
  return /*#__PURE__*/_react.default.createElement(_Field.default, _extends({}, props, {
    className: "text-area-field"
  }), function (fieldProps) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "control"
    }, /*#__PURE__*/_react.default.createElement(SimpleTextAreaField, _extends({}, props, fieldProps)));
  });
}

TextAreaField.propTypes = SimpleTextAreaField.propTypes = {
  label: _propTypes.default.any,
  value: _propTypes.default.any,
  textareaProps: _propTypes.default.object,
  className: _propTypes.default.string,
  inline: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  danger: _propTypes.default.bool,
  success: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['small', 'medium', 'large', 'normal'])
};
TextAreaField.defaultProps = SimpleTextAreaField.defaultProps = {
  onChange: function onChange() {},
  size: 'normal'
};